import React from 'react';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

const SkeletonLoader = () => {
  return (
    <div style={{padding:20}}>
      <Skeleton count={20} />
    </div>
  );
};

export default SkeletonLoader;
